import React from 'react';

const EmptyState = () => (
    <div className="text-center py-5">
        <p className="mb-0 text-muted">No transactions found</p>
    </div>
);

export default EmptyState;
